import PropTypes from 'prop-types';
import React from 'react';
import { getOrgTermsContent } from '../../../../content/utils.js';
import PageHeader from '../../PageHeader.js';
import InitiativeTabs from '../../../initiatives/InitiativeTabs.jsx';
import BreadCrumbs from '../../../BreadCrumbs.jsx';
import ProjectBreadcrumbIcon from '../../../icons/ProjectBreadcrumbIcon.jsx';
import styles from './ChangeInsightRespondentAnswersHeader.module.css';
import {
  ChangeInsightsStudioLink,
  InitiativeLink,
  ProjectLink,
  ProjectsLink,
} from '../../../links/index.jsx';

const ChangeInsightRespondentAnswersHeader = ({
  slug,
  initiative,
  respondentAnswers,
}) => {
  const { type, project } = initiative;

  const initiativePage = window.location.pathname;

  return (
    <PageHeader
      large={false}
      navigation={<InitiativeTabs slug={slug} initiative={initiative} />}
    >
      <div className={`flex ${styles.flexJustify}`}>
        <BreadCrumbs icon={<ProjectBreadcrumbIcon />}>
          <ProjectsLink>{getOrgTermsContent('projects')}</ProjectsLink>
          <ProjectLink projectId={project.id}>{project.name}</ProjectLink>

          {initiativePage === '/initiatives/show' ? (
            <span>{initiative.title}</span>
          ) : null}

          {initiativePage === '/change-insights/show' ||
          initiativePage === '/initiatives/files' ? (
            <InitiativeLink initiative={initiative}>
              {initiative.title}
            </InitiativeLink>
          ) : null}

          {initiativePage.includes('/change-insights') ? (
            <InitiativeLink initiative={initiative}>
              {initiative.title}
            </InitiativeLink>
          ) : null}

          {initiativePage.includes('/change-insights') ? (
            <ChangeInsightsStudioLink initiative={initiative}>
              ChangeInsights Studio
            </ChangeInsightsStudioLink>
          ) : null}

          {initiativePage.includes('change-insights/respondent-answers') ? (
            <span>
              {respondentAnswers ? respondentAnswers.responderName : ''}
            </span>
          ) : null}
        </BreadCrumbs>
      </div>
    </PageHeader>
  );
};

ChangeInsightRespondentAnswersHeader.propTypes = {
  initiative: PropTypes.shape({
    type: PropTypes.string.isRequired,
    category: PropTypes.string.isRequired,
    project: PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default ChangeInsightRespondentAnswersHeader;
